


























































































































































import { Component, Vue } from 'vue-property-decorator';
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { ObjectFactory } from '../config/objectFactory';
import { SignupRequest } from '../types/request';
import { MedTransGoConstants } from '../util/constants';
import { CommonUtils } from '../util/commonUtils';
import MessageBox from '../components/MessageBox.vue';

@Component({
    mixins: [validationMixin],
    data() {
        return {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            password: '',
            confirmPassword: '',
            lienCustomer: false,
            affiliatedWith: '',
            affiliatedWithLawFirm: '',
            affiliatedWithHealthCareFacility: '',
            iAgree: 'NotAccepted',
            number: Math.floor(Math.random() * 6) + 1,
        };
    },
    methods: {
        togglePassword: CommonUtils.togglePassword,
    },
    components: {
        MessageBox,
    },
    validations() {
        const validations = {
            email: {
                required,
                email,
            },
            firstName: {
                required,
                regex: (firstName: string) => /^[a-zA-Z ]+$/.test(firstName),
            },
            lastName: {
                required,
                regex: (lastName: string) => /^[a-zA-Z ]+$/.test(lastName),
            },
            password: {
                required,
                minLength: minLength(8),
                regex: (password: string) =>  MedTransGoConstants.PASSWORD_REGX.test(password),
            },
            confirmPassword: {
                required,
                sameAs: sameAs('password'),
            },
            phone: {
                required,
                minLength: minLength(10),
                regex: (phone: string) => MedTransGoConstants.PHONE_REGX.test(phone),
            },
            iAgree: {
                required,
            },
            lienCustomer: {
                required,
            },
            affiliatedWith: {
                required,
            },
        };
        if (!this.$data.lienCustomer) {
            delete validations.affiliatedWith;
        }
        return validations;
    },
})
export default class SignupPage extends Vue {

    private loginUrl: string = '';
    private errors: any = [];
    private disableSignup = false;
    private state = false;
    private messageLn: string = '';
    // lifecycle hook
    public mounted() {
        this.loginUrl = `${this.$store.state.serverUrl}${MedTransGoConstants.HTTP_URL_LOGIN}?clientId=${this.$store.state.clientId}`;
    }

    // User registration
    private async doSignup() {
        this.disableSignup = true;
        this.errors = [];
        const signupRequest: SignupRequest = {
            fullName: this.$data.firstName + ' ' + this.$data.lastName,
            password: this.$data.password,
            email: this.$data.email,
            phone: this.$data.phone,
            lienCustomer: this.$data.lienCustomer,
            clientId: this.$store.state.clientId,
            affiliatedWith: this.$data.affiliatedWith,
            affiliatedWithHealthcare: this.$data.affiliatedWithHealthCareFacility ? true : false,
            affiliatedWithAttorney: this.$data.affiliatedWithLawFirm ? true : false,
        };
        const response = await ObjectFactory.getMemberService().
            doSignup(this.$store.state.serverUrl, signupRequest);

        // This usually applies to lien customers. They do not get a token when they sign up
        // because their status is VERIFICATION_PENDING.
        if (response.success && response.data === 'Registered') {
            location.href = '/pending-verification';
        } else if (response.success) {
            const redirectTo = `/callback?${MedTransGoConstants.FIELD_NAME_TOKEN}=${response.data}`;
            location.href = redirectTo;
        } else {
            this.errors = [];
            if (response.errors && response.errors.length > 0) {
                this.errors = response.errors;
            } else {
                this.errors = [CommonUtils.translateErrorCode(response.errorCode)];
            }
            setTimeout(() => {
                this.errors = [];
            }, 2000);
            this.disableSignup = false;
        }
    }
    private logout() {
        CommonUtils.logout(this.$store.state);
    }
    private async phoneNumberMask() {
        const replaceInput = this.$data.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        this.$data.phone = !replaceInput[2] ? replaceInput[1] :
            replaceInput[1] + '-' + replaceInput[2] + (replaceInput[3] ? '-' + replaceInput[3] : '');
    }
}
